<template>
  <div class="content-wapper">
    <div class="table-operator button-wrapper">
      <a-button id="printButton" @click="printInvoice" type="primary" icon="printer">打印</a-button>
      <a-button id="printButton" @click="downloadInvoice" type="primary" icon="download">下载</a-button>
    </div>

    <div id="print" class="invoice-content">
      <div class="title">总部发票开具申请</div>
      <div class="company">
        <span class="print-item">山东九安保险经纪股份有限公司</span>
        <span>申请日期：{{year}}-{{month}}-{{date}}</span>
      </div>
      <div>
        <table class="table" border="1">
          <tr>
            <td class="item-column">审批编码</td>
            <td class="data-column">{{invoice.invoiceNumber}}</td>
          </tr>
          <tr>
            <td class="item-column">开票单位</td>
            <td class="data-column">{{invoice.invoiceUnit_dictText}}</td>
          </tr>
          <tr>
            <td>申请人</td>
            <td>{{invoice.user_dictText}}</td>
          </tr>
          <tr>
            <td>申请人部门</td>
            <td>{{invoice.userDep_dictText}}</td>
          </tr>
          <tr>
            <td>项目名称</td>
            <td>{{invoice.project_dictText}}</td>
          </tr>
          <tr>
            <td>业务类型</td>
            <td>{{invoice.businessType_dictText}}</td>
          </tr>
          <tr>
            <td>佣金计算方式</td>
            <td>{{invoice.brokerageWay_dictText}}</td>
          </tr>
          <tr>
            <td>部门名称</td>
            <td>{{invoice.insuranceDep_dictText}}</td>
          </tr>
          <tr>
            <td>经纪人</td>
            <td>{{invoice.broker_dictText}}</td>
          </tr>
          <tr>
            <td>发票类型</td>
            <td>{{invoice.invoiceType_dictText}}</td>
          </tr>
          <tr>
            <td>购买方名称</td>
            <td>{{invoice.consumerName}}</td>
          </tr>
          <tr>
            <td>购买方纳税人识别号</td>
            <td>{{invoice.consumerIdentification}}</td>
          </tr>
          <tr>
            <td>购买方地址</td>
            <td>{{invoice.consumerAddress}}</td>
          </tr>
          <tr>
            <td>购买方电话</td>
            <td>{{invoice.consumerPhone}}</td>
          </tr>
          <tr>
            <td>购买方开户行</td>
            <td>{{invoice.consumerBankName}}</td>
          </tr>
          <tr>
            <td>购买方账号</td>
            <td>{{invoice.consumerBankNumber}}</td>
          </tr>
          <tr>
            <td>发票开具内容</td>
            <td>{{invoice.invoiceContent_dictText}}</td>
          </tr>
          <tr>
            <td>保费</td>
            <td>{{invoice.rate.toFixed(2)}}</td>
          </tr>
          <tr>
            <td>净保费</td>
            <td>{{invoice.cleanPremium}}</td>
          </tr>
          <tr>
            <td>金额（元）</td>
            <td>{{invoice.money.toFixed(2)}}</td>
          </tr>
          <tr>
            <td>税额（元）</td>
            <td>{{invoice.tax.toFixed(2)}}</td>
          </tr>
          <tr>
            <td>价税合计（元）</td>
            <td>{{invoice.sumPriceTax.toFixed(2)}}</td>
          </tr>
          <!--<tr>-->
            <!--<td>保险公司明细</td>-->
            <!--<td>{{invoice.insuranceCompanyInfo}}</td>-->
          <!--</tr>-->
          <tr>
            <td>备注</td>
            <td>{{invoice.ps}}</td>
          </tr>
        </table>
      </div>
      <div class="printInfo">
        <span class="print-item">打印时间：{{year}}-{{month}}-{{date}} {{hours}}:{{minutes}}</span>
        <span >打印人：{{nickName}}</span>
      </div>

      <!-- 第二页：业绩统计 -->
      <div v-if="statsList && statsList.length > 0 && (invoice.project === '32' || invoice.project === '0')" class="stats-page">
        <div class="title">业绩统计明细</div>
        <div class="company">
          <span class="print-item">山东九安保险经纪股份有限公司</span>
          <span>审批编码：{{invoice.invoiceNumber}}</span>
        </div>
        <div>
          <!-- 山能：二级单位 / 业务类型 / 总保费 / 总佣金（同二级单位下按业务类型分行） -->
          <table v-if="invoice.project === '32'" class="table" border="1">
            <tr>
              <th class="stats-th">二级单位</th>
              <th class="stats-th">业务类型</th>
              <th class="stats-th">总保费（元）</th>
              <th class="stats-th">净保费（元）</th>
              <th class="stats-th">总佣金（元）</th>
            </tr>
            <tr v-for="(item, index) in statsList" :key="index">
              <td>{{item.orgName || '-'}}</td>
              <td>{{item.businessType_dictText || '-'}}</td>
              <td>{{formatMoney(item.totalPremium)}}</td>
              <td>{{formatMoney(item.totalCleanPremium)}}</td>
              <td>{{formatMoney(item.totalBrokerage)}}</td>
            </tr>
          </table>
          <!-- 鲁商：内外部 / 业务类型 / 总保费 / 总佣金 -->
          <table v-else class="table" border="1">
            <tr>
              <th class="stats-th">内外部客户</th>
              <th class="stats-th">业务类型</th>
              <th class="stats-th">总保费（元）</th>
              <th class="stats-th">净保费（元）</th>
              <th class="stats-th">总佣金（元）</th>
            </tr>
            <tr v-for="(item, index) in statsList" :key="index">
              <td>{{item.insideOutside === '2' ? '外部客户' : item.insideOutside === '3' ? '个人直拓' : '内部客户'}}</td>
              <td>{{item.businessType_dictText || '-'}}</td>
              <td>{{formatMoney(item.totalPremium)}}</td>
              <td>{{formatMoney(item.totalCleanPremium)}}</td>
              <td>{{formatMoney(item.totalBrokerage)}}</td>
            </tr>
          </table>
        </div>
        <div class="printInfo">
          <span class="print-item">打印时间：{{year}}-{{month}}-{{date}} {{hours}}:{{minutes}}</span>
          <span>打印人：{{nickName}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import jsPDF from 'jspdf'
  import html2canvas from 'html2canvas'

  export default {
    name: 'print',
    data (){
      return {
        invoice:{},
        statsList:[],
        year:'',
        month:'',
        date:'',
        hours:'',
        minutes:'',
        nickName:''
      }
    },
    created() {
      this.invoice = JSON.parse(sessionStorage.getItem("PRINT_INVOICE") || "{}");
      this.statsList = JSON.parse(sessionStorage.getItem("PRINT_INVOICE_STATS") || "[]");
      this.nickName = this.nickname();
      if(this.nickName == null || this.nickName == undefined || this.nickName == ''){
        this.$message.warning("请重新登录")
      }
      this.getTime();
    },
    methods:{
      ...mapGetters(["nickname", "userInfo"]),
      getTime(){
        var now = new Date();
        this.year = now.getFullYear();
        this.month = (now.getMonth()+1).toString().padStart(2,'0');
        this.date = (now.getDate()).toString().padStart(2,'0');
        this.hours = (now.getHours()).toString().padStart(2,'0');
        this.minutes = (now.getMinutes()).toString().padStart(2,'0');
      },
      printInvoice() {
        this.setWindowListener();
        document.body.innerHTML=document.getElementById('print').innerHTML;
        window.print();
      },

      setWindowListener(){
        let that = this;
        var innerHTML = document.body.innerHTML;
        //定义打印前事件
        var beforePrint = function() {
          //console.log("beforePrint:" + innerHTML);
        };
        //定义打印后事件
        var afterPrint = function() {
          that.$message.info("打印完成");
          document.body.innerHTML = innerHTML;
          document.getElementById('printButton').onclick = that.printInvoice;
        }
        window.onbeforeprint = beforePrint;
        window.onafterprint = afterPrint;
      },

      downloadInvoice(){
        let print = document.getElementById('print')
        this.exportPdf(print,'总部发票开具申请')
      },

      formatMoney(val) {
        if (val == null) return '0.00';
        return Number(val).toFixed(2);
      },

      exportPdf(target, pdfName){
        html2canvas(target).then(function(canvas){
            let imgWidth = 595.28
            let imgHeight = 595.28 * canvas.width / canvas.height
            let pageData = canvas.toDataURL('image/jpeg', 1.0)
            let pdf = new jsPDF('p', 'pt', 'a4') //纵向、pt单位、a4大小, 见库说明
            pdf.addImage(pageData, 'JPEG', 0,0, imgWidth, imgHeight)
            pdf.save(`${pdfName}.pdf`, pdf)
          }
        )
      },

    }
  }

</script>

<style scoped>
  @import '~@assets/less/common.less';

  .content-wapper{
    background-color: white;
    width: 100%;
  }
  .button-wrapper{
    height: 80px;
    padding: 20px 40px;
    border-bottom: 1px solid #ccc;
  }
  .invoice-content{
    width: 710px;
    background-color: #fff;
    padding:20px 20px;
    font-size: 10px;
  }
  .title{
    font-size: 25px;
    margin-left: 250px;
    margin-bottom: 20px;
  }
  .company{
    margin: 0 0 20px 20px;
  }
  .printInfo{
    margin: 0 0 20px 20px;
  }
  .print-item{
    margin-right: 20px;
  }
  table {
    border-collapse: collapse;
    margin: 0 0 20px 20px;
  }
  th, td {
    padding: 5px 15px;
  }
  .item-column{
    width: 160px;
  }
  .data-column{
    width: 480px;
  }
  .stats-page{
    page-break-before: always;
    padding-top: 20px;
  }
  .stats-th{
    background-color: #f0f0f0;
    font-weight: bold;
    padding: 5px 15px;
  }
</style>